import { csvDownloadConstants } from '../../_constants';

const initialState = { csvDownloadLoading: true, data: '', error: false };

export function csvDownloadReducer(state = initialState, action) {

    switch (action.type) {
        case csvDownloadConstants.REQUEST_CSV_DOWNLOAD:
            return {
                csvDownloadLoading: true,
                data: '',
                error: false
            };
        case csvDownloadConstants.RECIEVE_CSV_DOWNLOAD:
            return {
                csvDownloadLoading: false,
                data: action.csvDownload,
                error: false
            };
        case csvDownloadConstants.ERROR_CSV_DOWNLOAD:
            return {
                csvDownloadLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/csvDownload/csvDownload.reducer.js